import React from "react";
import PropTypes from "prop-types";
import Fade from "react-reveal/Fade";
import Box from "common/components/Box";
import Text from "common/components/Text";
import Heading from "common/components/Heading";
import Button from "common/components/Button";
import Card from "common/components/Card";
import Image from "common/components/Image";
import FeatureBlock from "common/components/FeatureBlock";
import Container from "common/components/UI/Container";
import { PaymentCircleShape } from "../app.style";

import ImageOne from "common/assets/image/app/mockup.png";
import ImageTwo from "common/assets/image/app/credit-card.png";

const PaymentSection = ({
	sectionWrapper,
	row,
	col,
	title,
	description,
	button,
	textArea,
	imageArea,
	textAreaRow,
	imageAreaRow,
	imageWrapper,
	imageWrapperOne,
	imageWrapperTwo,
	sectionSubTitle,
	btnStyle,
}) => {
	return (
		<Box {...sectionWrapper} id='payments'>
			<PaymentCircleShape />

			<Container fullWidth noGutter className='control-sec-container payment'>
				<Box {...row} {...imageAreaRow}>
					<Box {...col} {...imageArea}>
						<Card {...imageWrapper} {...imageWrapperOne}>
							<Fade left>
								<Image src={ImageOne} alt='Info Image One' />
							</Fade>
						</Card>
						<Card
							{...imageWrapper}
							{...imageWrapperTwo}
							className='cardExtraImage'>
							<Fade right>
								<Image src={ImageTwo} alt='Info Image Two' />
							</Fade>
						</Card>
					</Box>
				</Box>
			</Container>
			<Container>
				<Box {...row} {...textAreaRow}>
					<Box {...col} {...textArea}>
						<Text content='AUTHENTIC SOURCES' {...sectionSubTitle} />
						<FeatureBlock
							title={
								<Heading
									content='Full Reference to Source Books of Ahadith provided'
									{...title}
								/>
							}
							description={
								<Text
									content='Islam360 app is continuously updating and adding more books and features for the benefit of the Muslim Ummah! May Allah reward you for your interest in the original sources of knowledge of our Deen!.
'
									{...description}
								/>
							}
							button={
								<a
									href='https://linktr.ee/islam360'
									target='_blank'
									rel='noreferrer'>
									{" "}
									<Button title='HOW IT WORKS' {...button} {...btnStyle} />
								</a>
							}
						/>
					</Box>
				</Box>
			</Container>
		</Box>
	);
};

PaymentSection.propTypes = {
	sectionWrapper: PropTypes.object,
	row: PropTypes.object,
	col: PropTypes.object,
	title: PropTypes.object,
	description: PropTypes.object,
	button: PropTypes.object,
	btnStyle: PropTypes.object,
};

PaymentSection.defaultProps = {
	sectionWrapper: {
		as: "section",
		pt: ["20px", "40px", "40px", "80px", "80px"],
		pb: ["80px", "80px", "80px", "180px", "280px"],
	},
	row: {
		flexBox: true,
		flexWrap: "wrap",
		ml: "-15px",
		mr: "-15px",
	},
	textAreaRow: {
		flexDirection: "row-reverse",
	},
	col: {
		pr: "15px",
		pl: "15px",
	},
	textArea: {
		width: [1, 1, "45%", "45%", "45%"],
		zIndex: "1",
	},
	imageArea: {
		width: [0, 0, "52%", "45%", "45%"],
		flexBox: true,
	},
	imageWrapper: {
		boxShadow: "none",
	},
	imageWrapperOne: {
		pointerEvents: "none",
	},
	imageWrapperTwo: {
		alignSelf: "flex-start",
		mt: ["0px", "0px", "40px", "50px", "90px"],
		ml: ["-250px", "-250px", "-180px", "-220px", "-420px"],
		pointerEvents: "none",
	},
	sectionSubTitle: {
		as: "span",
		display: "block",
		textAlign: ["center", "left"],
		fontSize: "14px",
		letterSpacing: "0.11em",
		fontWeight: "700",
		color: "#3F9A02",
		textTransform: "uppercase",
		mb: "10px",
	},
	title: {
		fontSize: ["24px", "26px", "30px", "36px", "48px"],
		fontWeight: "300",
		color: "#0f2137",
		letterSpacing: "-0.010em",
		mb: "20px",
		maxWidth: ["100%", "100%", "100%", "420px", "420px"],
		textAlign: ["center", "left"],
	},
	description: {
		fontSize: "16px",
		color: "#343d48cc",
		lineHeight: "2.1",
		mb: "33px",
		maxWidth: ["100%", "100%", "100%", "440px", "440px"],
		textAlign: ["center", "left"],
	},
	button: {
		type: "button",
		fontSize: "14px",
		fontWeight: "600",
		color: "#fff",
		borderRadius: "4px",
		pl: "22px",
		pr: "22px",
		colors: "primaryWithBg",
	},
	btnStyle: {
		minWidth: "156px",
		fontSize: "14px",
		fontWeight: "500",
	},
};

export default PaymentSection;
